import request from '@/utils/request'


// 查询用户压力记录列表
export function listPressure(query) {
  return request({
    url: '/joe/user-pressure/list',
    method: 'get',
    params: query
  })
}

// 查询用户压力记录分页
export function pagePressure(query) {
  return request({
    url: '/joe/user-pressure/page',
    method: 'get',
    params: query
  })
}

// 查询用户压力记录详细
export function getPressure(data) {
  return request({
    url: '/joe/user-pressure/detail',
    method: 'get',
    params: data
  })
}

// 新增用户压力记录
export function addPressure(data) {
  return request({
    url: '/joe/user-pressure/add',
    method: 'post',
    data: data
  })
}

// 修改用户压力记录
export function updatePressure(data) {
  return request({
    url: '/joe/user-pressure/edit',
    method: 'post',
    data: data
  })
}

// 删除用户压力记录
export function delPressure(data) {
  return request({
    url: '/joe/user-pressure/delete',
    method: 'post',
    data: data
  })
}
